export default "__VITE_ASSET__lluQUx$w__"